import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'

import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../components/Form/Field'
import TextareaField from '../../../../../../../../components/Form/TextareaField'
import DatePicker from '../../../../../../../../components/DatePicker'
import ErrorMessage from '../../../../../../../../components/Form/ErrorMessage'

import { formatConventionName } from '../helpers'

import { selectedPartnershipSelector } from '../../../../../../../../modules/selectors/partnerships'

import { EXPECTED_START_DATE, OPTIONAL_TAG, SHORT_CAMPAIGN_DESCRIPTION } from '../fields'
import { DATES_FORMAT_LONG } from '../../../../../../../../constants/dates'

import useStyles from './styles'

const NamingConventionContent = ({ formik }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const { values, errors, touched, setFieldValue } = formik

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const formattedConventionName = useMemo(() => {
    return formatConventionName(values, selectedPartnership)
  }, [values, selectedPartnership])

  const expectedStartDatePlacePlaceholder = useMemo(() => {
    // Expected Start Date: e.g. {Today + 1} e.g. 06 February 2024
    const nextDay = new Date()
    nextDay.setDate(nextDay.getDate() + 1)
    return 'e.g. ' + format(nextDay, DATES_FORMAT_LONG)
  }, [])

  const handleStartDatePickerChange = useCallback(
    value => {
      setFieldValue(EXPECTED_START_DATE, value)
    },
    [setFieldValue]
  )

  return (
    <>
      <p>
        {t(
          'Enter a short campaign description and expected start date to generate a campaign name in the recommended naming convention.'
        )}
      </p>

      <FieldLabelWrapper label={t('Short Campaign Description')} labelFor={SHORT_CAMPAIGN_DESCRIPTION}>
        <Field
          placeholder={t('e.g. Summer Sale')}
          formik={formik}
          name={SHORT_CAMPAIGN_DESCRIPTION}
          disablePlaceholderFormatting={true}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Expected Start Date')}>
        <DatePicker
          placeholder={expectedStartDatePlacePlaceholder}
          value={values[EXPECTED_START_DATE]}
          changeHandler={handleStartDatePickerChange}
        />
        {errors[EXPECTED_START_DATE] && touched[EXPECTED_START_DATE] && (
          <ErrorMessage error={errors[EXPECTED_START_DATE]} />
        )}
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Optional Tag')} labelFor={OPTIONAL_TAG}>
        <Field placeholder={t('e.g. 001')} formik={formik} name={OPTIONAL_TAG} disablePlaceholderFormatting={true} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Final Campaign Name')} key={formattedConventionName}>
        <TextareaField
          setFieldValue={setFieldValue}
          formikValue={formattedConventionName}
          disabled={true}
          className={classes.finalCampaignName}
        />
      </FieldLabelWrapper>
    </>
  )
}

export default NamingConventionContent
